<template>
  <div class="w-full">
    <div class="flex items-center justify-end w-full lg:items-start">
      <div class="relative block w-full mr-5 lg:hidden">
        <div
          class="relative w-full mb-2 overflow-hidden bg-transparent border-b text-light-black border-light-black"
        >
          <i
            class="absolute right-0 z-10 text-xs transform -translate-y-1/2 pointer-events-none icon-chevron-down top-1/2 text-light-black"
          ></i>
          <select
            :value="active_category"
            @input="
              $router.push(`/collections?category=${$event.target.value}`)
            "
            class="relative w-full py-2 pr-5 bg-transparent appearance-none focus:outline-none"
          >
            <option value="all" class="text-light-black">全部商品</option>
            <optgroup
              v-for="(menu, menu_index) in menu_category_data"
              :label="menu.Title"
              :key="`menu_category_${menu_index}`"
            >
              <option
                v-for="(item, item_index) in GetCategoryMenu(
                  menu.MenuCategoryID
                )"
                :key="`menu_item_${menu_index}_${item_index}`"
                :value="item.MenuID"
                class="text-light-black"
              >
                {{ item.Title }}
              </option>
            </optgroup>
          </select>
        </div>
      </div>
      <div class="relative hidden lg:block lg:w-64">
        <div
          class="relative w-full overflow-hidden bg-transparent border-b text-light-black border-light-black"
        >
          <i
            class="absolute right-0 z-10 text-xs transform -translate-y-1/2 pointer-events-none icon-chevron-down top-1/2 text-light-black"
          ></i>
          <select
            :value="sort_type"
            @input="$emit('change-sort', $event.target.value)"
            class="relative w-full py-2 pr-5 bg-transparent appearance-none focus:outline-none"
          >
            <option class="bg-transparent text-light-black">推薦排序</option>
            <option class="bg-transparent text-light-black">
              價錢由低到高
            </option>
            <option class="bg-transparent text-light-black">
              價錢由高到低
            </option>
            <option class="bg-transparent text-light-black">
              時間由舊到新
            </option>
            <option class="bg-transparent text-light-black">
              時間由新到舊
            </option>
          </select>
        </div>
      </div>
      <div class="block lg:hidden">
        <button
          @click="$emit('open-filter-dialog')"
          class="flex items-center justify-center"
        >
          <i class="block text-2xl icon-equalizer"></i>
        </button>
      </div>
    </div>

    <p class="block text-xs text-zinc-400 work_sans lg:hidden">
      {{ category_product_data.length }} 項商品
    </p>
  </div>
</template>

<script>
export default {
  name: "ProductListFilterBar",
  props: {
    menu_category_data: {
      require: true,
      type: Array,
    },
    category_data: {
      require: true,
      type: Array,
    },
    active_category: {
      require: true,
      type: String,
      default: "all",
    },
    sort_type: {
      require: true,
      type: String,
      default: "推薦排序",
    },
    category_product_data: {
      require: true,
      type: Array,
    },
  },
  methods: {
    GetCategoryMenu(id) {
      return this.category_data.filter((item) => item.MenuCategoryID == id);
    },
  },
};
</script>
